// Mirrors the @calendly/ui copy installed with @calendly/booking-kit.
// SCH-5152. The durable one-copy change replaces this object.
export const bookingBreakpoints = {
  isPhone: { maxWidth: 895 },
  isTabletDown: { maxWidth: 1119 },
  isTablet: { minWidth: 896, maxWidth: 1119 },
  isTabletUp: { minWidth: 896 },
  isDesktopUp: { minWidth: 1120 },
}
